require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-laravel-dynamic-menu-best-for-admin-packages.json") })
        }
      }, "path---post-laravel-dynamic-menu-best-for-admin-packages");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-laravel-dynamic-menu-best-for-admin-packages!./.cache/json/post-laravel-dynamic-menu-best-for-admin-packages.json
// module id = 335
// module chunks = 231608221292675